// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "boxicons"

// Make Bootstrap available globally for data-bs-* attributes
window.bootstrap = bootstrap
